import { remoteCommandKeys } from './constants';
import { prependCommand, replaceCommand } from './remoteCommandsUtils';

/** Infinite data with `row` first in pages[0] and no older copy of its id in any page. */
export const prependToInfinite = (data, row) => {
	if (!data?.pages?.length) return data;
	const [first, ...rest] = data.pages;
	const others = rest.map((page) => page.filter((item) => String(item.id) !== String(row.id)));
	return { ...data, pages: [prependCommand(first, row), ...others] };
};

/** Infinite data with `row` in place of the item with its id, wherever it is; unchanged when absent. */
export const replaceInInfinite = (data, row) => {
	if (!data?.pages?.length) return data;
	const pages = data.pages.map((page) => replaceCommand(page, row));
	if (pages.every((page, index) => page === data.pages[index])) return data;
	return { ...data, pages };
};

/** Every cached copy of a command (single, current, history), for the "was it active here?" check. */
export const cachedCopies = (client, row) => {
	const latest = client.getQueryData(remoteCommandKeys.latest(row.unitId)) ?? [];
	const history = client.getQueryData(remoteCommandKeys.history(row.unitId))?.pages ?? [];
	const sameId = (item) => String(item.id) === String(row.id);
	return [client.getQueryData(remoteCommandKeys.one(row.id)), ...latest.filter(sameId), ...history.flat().filter(sameId)].filter(
		Boolean,
	);
};

/** A command the user just sent: it becomes the current command and the head of the history. */
export const addSentCommand = (client, unitId, row) => {
	client.setQueryData(remoteCommandKeys.latest(unitId), (list) => prependCommand(list, row).slice(0, 1));
	client.setQueryData(remoteCommandKeys.history(unitId), (data) => prependToInfinite(data, row));
	client.setQueryData(remoteCommandKeys.one(row.id), row);
};

/** A newer version of a known command (socket or refetch): replaced wherever it is cached. */
export const updateCommand = (client, row) => {
	if (client.getQueryData(remoteCommandKeys.latest(row.unitId))) {
		client.setQueryData(remoteCommandKeys.latest(row.unitId), (list) => replaceCommand(list, row));
	}
	if (client.getQueryData(remoteCommandKeys.history(row.unitId))) {
		client.setQueryData(remoteCommandKeys.history(row.unitId), (data) => replaceInInfinite(data, row));
	}
	client.setQueryData(remoteCommandKeys.one(row.id), row);
};
